export const AssetWorkspaceTab = {
	Form: "form",
	Records: "records",
	Attachments: "attachments",
	Notes: "notes",
	Map: "map",
} as const;

export type AssetWorkspaceTabId =
	(typeof AssetWorkspaceTab)[keyof typeof AssetWorkspaceTab];

const ASSET_WORKSPACE_TAB_IDS = new Set<string>(
	Object.values(AssetWorkspaceTab),
);

/**
 * Reads the nested asset workspace tab from a pathname.
 * Uses the first segment after `/assets/$assetId/workspace/`.
 */
export function getAssetWorkspaceTabId(pathname: string): AssetWorkspaceTabId {
	const match = pathname.match(
		/\/workspace\/assets\/[^/]+\/workspace(?:\/([^/]+))?/,
	);
	if (!match) return AssetWorkspaceTab.Form;
	const segment = match[1] ?? "";
	if (ASSET_WORKSPACE_TAB_IDS.has(segment)) {
		return segment as AssetWorkspaceTabId;
	}
	return AssetWorkspaceTab.Form;
}
